import { formatPortalLabel } from "utils/portal-access";

const resolveMatchExternalCta = (match: any) => {
  if (match.live_links?.stream_url) {
    return {
      ctaHref: match.live_links.stream_url,
      ctaLabel: match.live_links?.stream_label || "Watch live",
    };
  }

  if (match.live_links?.score_url) {
    return {
      ctaHref: match.live_links.score_url,
      ctaLabel: "Open live score",
    };
  }

  if (match.live_links?.meeting_url) {
    return {
      ctaHref: match.live_links.meeting_url,
      ctaLabel: "Open external link",
    };
  }

  return null;
};

const resolveRosterTaskMatchId = (task: any) =>
  task?.school_match_id || task?.match_id || task?.school_match?.id;

export const buildSchoolCalendarItems = (dashboard: any) => {
  const upcomingMatches = dashboard?.upcoming_matches || [];
  const rosterTasks = dashboard?.roster_tasks || [];

  return [
    ...upcomingMatches.map((match: any) => {
      const externalCta = resolveMatchExternalCta(match);
      const internalCta =
        match.id && !externalCta
          ? {
              ctaHref: `/workspace/school-matches/${match.id}`,
              ctaLabel: "Open match",
            }
          : null;

      return {
        category: "match" as const,
        ctaHref: externalCta?.ctaHref || internalCta?.ctaHref,
        ctaLabel: externalCta?.ctaLabel || internalCta?.ctaLabel,
        details: [match.competition_name || match.match_type, match.result_summary]
          .filter(Boolean)
          .join(" | "),
        id: `school-calendar-match-${
          match.id || `${match.scheduled_at}-${match.competition_name || "fixture"}`
        }`,
        location: match.venue_name || match.venue_address || "Venue pending",
        start: match.scheduled_at,
        status: match.status || "scheduled",
        title:
          match.home_school_team?.name && match.away_school_team?.name
            ? `${match.home_school_team.name} vs ${match.away_school_team.name}`
            : match.competition_name || match.sport_name || "School fixture",
      };
    }),
    ...rosterTasks.map((task: any) => {
      const matchId = resolveRosterTaskMatchId(task);

      return {
        category: "task" as const,
        ctaHref: matchId ? `/workspace/school-matches/${matchId}?tab=rosters` : undefined,
        ctaLabel: matchId ? "Manage roster" : undefined,
        details: task.notes || `${formatPortalLabel(task.roster_status || "missing")} roster task`,
        id: `school-calendar-task-${task.id || `${task.school_team_id}-${task.scheduled_at}`}`,
        location:
          task.venue_name || task.venue_address || task.school_name || "School roster workflow",
        start: task.scheduled_at,
        status: task.roster_status || "missing",
        title: `${task.school_team_name || "Team"} roster deadline`,
      };
    }),
  ];
};

export const buildPlayerCalendarItems = (events: any[] = []) =>
  events.map((event: any, index: number) => ({
    category: "event" as const,
    details: event.details || event.description || "No event details provided yet.",
    end:
      event.end_date ||
      event.end ||
      event.date ||
      event.scheduled_at ||
      event.start_date ||
      event.start,
    id: event.id || `workspace-player-event-${index}`,
    location: event.location || event.venue_name || "Location pending",
    start: event.start_date || event.start || event.date || event.scheduled_at,
    status: event.status,
    title: event.name || event.title || "Untitled event",
  }));
